/** Classes do campo de texto da loja (borda cinza, raio grande, texto azul). */
export const inputClass = (hasError: boolean) =>
    `border border-calm-gray-ultralight h-12 text-sm rounded-xl w-full focus:outline-hidden px-2.5 items-center flex text-harmonic-blue ${
        hasError ? 'border-jolly-rose' : 'focus:border-secondary hover:border-strong-blue-light'
    }`

/**
 * Campo de busca com borda fina (o campo com borda do DaisyUI 4, escrito em utilitários): busca de produtos,
 * busca da ajuda e a chave do PIX.
 */
export const BORDERED_INPUT_CLASS =
    'shrink appearance-none h-12 px-4 text-base rounded-lg border border-base-content/20 bg-base-100 focus:shadow-none focus:border-base-content/20 focus:outline-2 focus:outline-offset-2 focus:outline-base-content/20'
